export type NavigationItem = {
  label: string;
  href: string;
};

export const headerNavigation: NavigationItem[] = [
  { label: "Home", href: "/" },
  { label: "Product", href: "/product" },
  { label: "Features", href: "/features" },
  { label: "Solutions", href: "/solutions" },
  { label: "Industries", href: "/industries" },
  { label: "Downloads", href: "/downloads" },
  { label: "Security", href: "/security" },
  { label: "Request Demo", href: "/request-demo" },
];

export const footerNavigation = {
  product: [
    { label: "Overview", href: "/product" },
    { label: "Features", href: "/features" },
    { label: "Downloads", href: "/downloads" },
    { label: "Security", href: "/security" },
  ],
  solutions: [
    { label: "Enterprises", href: "/solutions#enterprise-video-retention" },
    { label: "System Integrators", href: "/solutions#system-integrator-enablement" },
    { label: "VMS Service Providers", href: "/solutions#service-provider-cloud-archive" },
    { label: "Multi-Site Customers", href: "/solutions#multi-site-surveillance-management" },
  ],
  resources: [
    { label: "Documentation", href: "/docs" },
    { label: "Release Notes", href: "/downloads#release-notes" },
    { label: "Support", href: "/contact" },
  ],
  company: [
    { label: "About", href: "/about" },
    { label: "Contact", href: "/contact" },
    { label: "Request Demo", href: "/request-demo" },
  ],
};
